var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImagePick',{staticClass:"image-pick",attrs:{"allow-paste-url":true,"visible":_vm.newImageDialog},on:{"close":_vm.cancel,"change":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }